<form [formGroup]="shiftForm" (ngSubmit)="onSubmit()" autocomplete="off">

  <!-- Shift Name -->
  <div class="mb-5">
    <label class="block text-sm font-medium text-gray-700 mb-1">
      Shift Name <span class="text-red-500">*</span>
    </label>
    <input formControlName="shift_name" type="text" placeholder="e.g. Morning Shift"
      class="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition" />
    <p *ngIf="shiftForm.get('shift_name')?.invalid && shiftForm.get('shift_name')?.touched"
      class="mt-1 text-xs text-red-500">
      Shift name is required (min 2 characters).
    </p>
  </div>


  <!-- Timezone -->
  <div class="mb-5">
    <div class="flex items-center gap-1 mb-1">
      <label class="text-sm font-medium text-gray-700">
        Timezone <span class="text-red-500">*</span>
      </label>
      <mat-icon class="shift-info-icon text-gray-400 cursor-default"
        matTooltip="This timezone is used to calculate attendance summaries and shift eligibility."
        matTooltipPosition="above" aria-label="Timezone info">
        info_outline
      </mat-icon>
    </div>
    <mat-form-field appearance="outline" class="w-full shift-tz-field">
      <mat-label>Timezone</mat-label>

      <mat-select formControlName="timezone" panelClass="shift-tz-panel">
        <!-- Loading state -->
        <mat-option *ngIf="isLoadingTimezones" disabled>
          <div class="flex items-center gap-2 text-gray-500">
            <mat-icon class="animate-spin" style="font-size: 16px; height: 16px; width: 16px;">refresh</mat-icon>
            Loading timezones...
          </div>
        </mat-option>

        <!-- Search box (disabled option so it isn't selectable) -->
        <mat-option class="tz-search-option" disabled *ngIf="!isLoadingTimezones">
          <input [formControl]="timezoneSearchCtrl" type="text" placeholder="Search timezone..."
            class="w-full px-2 py-1 text-sm border-b border-gray-200 focus:outline-none"
            (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
        </mat-option>

        <mat-option *ngFor="let tz of filteredTimezones" [value]="tz.value">
          {{ tz.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Time Row -->
  <div class="shift-time-row">
    <!-- Start Time -->
    <div class="shift-time-col">
      <label class="block text-sm font-medium text-gray-700 mb-1">Start Time</label>
      <div class="shift-time-input-wrap">
        <input type="time" formControlName="start_time" class="shift-time-input" aria-label="Start Time" />
      </div>
    </div>

    <!-- End Time -->
    <div class="shift-time-col">
      <label class="block text-sm font-medium text-gray-700 mb-1">End Time</label>
      <div class="shift-time-input-wrap">
        <input type="time" formControlName="end_time" class="shift-time-input" aria-label="End Time" />
      </div>
    </div>
  </div>

  <!-- Duration badge -->
  <div class="flex items-center gap-3 mb-4">
    <span *ngIf="shiftDuration"
      class="inline-flex items-center gap-1 text-xs text-indigo-600 bg-indigo-50 px-2.5 py-1 rounded-full font-medium">
      <mat-icon style="font-size:13px;width:13px;height:13px;">timer</mat-icon>
      Duration: {{ shiftDuration }}{{ isOvernight ? ' (Overnight shift)' : '' }}
    </span>
  </div>


  <!-- Working Days -->
  <div class="mb-5">
    <div class="flex items-center gap-1 mb-2">
      <label class="text-sm font-medium text-gray-700">Working Days</label>
      <mat-icon class="shift-info-icon text-gray-400 cursor-default"
        matTooltip="Select the days when this shift is active. Only these days will be considered for attendance calculation."
        matTooltipPosition="above" aria-label="Working days info">
        info_outline
      </mat-icon>
    </div>
    <div class="shift-days-row">
      <button *ngFor="let day of workingDays" type="button" (click)="toggleDay(day.value)"
        [ngClass]="isDaySelected(day.value) ? 'shift-day-btn shift-day-btn--active' : 'shift-day-btn'">
        {{ day.label }}
      </button>
    </div>
    <p *ngIf="selectedDays.length === 0" class="mt-1 text-xs text-red-500">Select at least one working day.</p>
  </div>

  <!-- Buffer Time -->
  <!--
  <div class="mb-5">
    <div class="flex items-center gap-1 mb-2">
      <label class="text-sm font-medium text-gray-700">Buffer Time</label>
      <mat-icon class="shift-info-icon text-gray-400 cursor-default"
        matTooltip="Allow a grace period before and after shift times for clock-in/out flexibility."
        matTooltipPosition="above" aria-label="Buffer time info">
        info_outline
      </mat-icon>
    </div>
    <div class="shift-time-row">
      <div class="shift-time-col">
        <label class="block text-xs text-gray-500 mb-1">Start Buffer (min)</label>
        <div class="shift-time-input-wrap">
          <input type="number" formControlName="buffer_start_minutes" min="0" max="120" class="shift-time-input"
            placeholder="0" aria-label="Buffer start minutes" />
        </div>
        <p *ngIf="shiftForm.get('buffer_start_minutes').invalid && shiftForm.get('buffer_start_minutes').touched"
          class="mt-1 text-xs text-red-500">Value must be between 0 and 120.</p>
      </div>
      <div class="shift-time-col">
        <label class="block text-xs text-gray-500 mb-1">End Buffer (min)</label>
        <div class="shift-time-input-wrap">
          <input type="number" formControlName="buffer_end_minutes" min="0" max="120" class="shift-time-input"
            placeholder="0" aria-label="Buffer end minutes" />
        </div>
        <p *ngIf="shiftForm.get('buffer_end_minutes').invalid && shiftForm.get('buffer_end_minutes').touched"
          class="mt-1 text-xs text-red-500">Value must be between 0 and 120.</p>
      </div>
    </div>
  </div>
  -->

  <!-- Employee Assignment -->
  <div class="mb-5">
    <div class="flex items-center gap-1 mb-2">
      <label class="text-sm font-medium text-gray-700">Assign Employees</label>
      <mat-icon class="shift-info-icon text-gray-400 cursor-default"
        matTooltip="Select which employees belong to this shift. Employees not assigned here will appear as 'Needs Assignment'."
        matTooltipPosition="above" aria-label="Assign employees info">
        info_outline
      </mat-icon>
      <span *ngIf="selectedEmployeeIds.length > 0" class="emp-selected-badge">
        {{ selectedEmployeeIds.length }} selected
      </span>
    </div>

    <!-- Loading employees -->
    <div *ngIf="isLoadingEmployees" class="emp-loading">
      <mat-spinner diameter="20"></mat-spinner>
      <span class="text-sm text-gray-400">Loading employees...</span>
    </div>

    <ng-container *ngIf="!isLoadingEmployees">
      <ng-container *ngIf="shiftFormEmployees.length > 0; else noEmployees">
        <!-- Search -->
        <div class="emp-search-wrap mb-2">
          <mat-icon class="emp-search-icon">search</mat-icon>
          <input type="text" [(ngModel)]="employeeSearchQuery" [ngModelOptions]="{standalone: true}"
            placeholder="Search employees..." class="emp-search-input" aria-label="Search employees" />
          <button *ngIf="employeeSearchQuery" type="button" class="emp-search-clear" (click)="employeeSearchQuery = ''"
            aria-label="Clear search">
            <mat-icon style="font-size:16px;width:16px;height:16px;">close</mat-icon>
          </button>
        </div>

        <!-- Employee List -->
        <div class="emp-list-container">
          <div *ngIf="filteredEmployees.length === 0" class="emp-no-results">
            No employees match "{{ employeeSearchQuery }}"
          </div>
          <div *ngFor="let emp of filteredEmployees" class="emp-item"
            [class.emp-item--selected]="isEmployeeSelected(emp.user_id)">
            <mat-checkbox [checked]="isEmployeeSelected(emp.user_id)"
              (change)="toggleEmployee(emp.user_id, $event.checked)" color="primary">
              <span class="emp-name">{{ emp.name }}</span>
            </mat-checkbox>
            <span *ngIf="!emp.on_this_shift && emp.current_shift_name" class="emp-other-shift-badge">
              In {{ emp.current_shift_name }}
            </span>
          </div>
        </div>
      </ng-container>

      <ng-template #noEmployees>
        <div class="emp-empty-state">
          <mat-icon style="font-size:20px;width:20px;height:20px;color:#9ca3af;">group</mat-icon>
          <span class="text-sm text-gray-400">No employees available to assign.</span>
        </div>
      </ng-template>
    </ng-container>
  </div>

</form>